import React from 'react';
export function Footer() {
  return <footer className="defer-paint w-full bg-ink py-9" data-id="element-102" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-5xl px-6 text-center" data-id="element-103" data-mp="3gfsmebmgesmg">
        <p className="font-display text-lg tracking-[0.18em] text-ivory" data-id="element-104" data-mp="3ghc323c0v5or">
          THE ART FLOW <span className="text-gold" data-id="element-105" data-mp="32pp6e2e63v5g">ARCHIVE™</span>
        </p>
        <p className="mt-4 font-display text-base tracking-[0.22em] text-ivory/50" data-id="element-106" data-mp="36ooajks2rnvu">
          PLAN · TEACH · CREATE
        </p>
        <div className="mx-auto mt-7 h-px w-16 bg-gold/50" aria-hidden="true" data-id="element-107" data-mp="3ufjujvqahesj" />
        <p className="mt-7 font-sans text-xs leading-relaxed text-ivory/55" data-id="element-108" data-mp="37o74x94c1ef">
          © 2024 THE ART FLOW ARCHIVE™ — All rights reserved.
        </p>
        <p className="mx-auto mt-2 max-w-xl font-sans text-[11px] leading-relaxed text-ivory/40" data-id="element-109" data-mp="3lgosmvua2qv1">
          This digital product is designed for art teachers seeking to improve
          their classroom planning and teaching efficiency. Built for art
          educators who deserve better tools.
        </p>
      </div>
    </footer>;
}